import { useState } from 'react';

import { useTranslation } from '../../../../hooks/useTranslation';
import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useMessageTypeOptions } from './useMessageTypeOptions';
import { ValidatedMultiStringValueInputProps } from '../types';

export const MultiMessageTypeSelect = ({
  onChange,
  value,
  isInvalid,
  isOpenByDefault,
  hasWarning,
  dataType,
  field,
  fieldType,
  comparator,
  optionsLimit,
}: ValidatedMultiStringValueInputProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const { ConditionValueMultiStringSelect: VisualComponent } = useVisualComponentsContext();
  const { isReadOnly } = useQueryStateContext();
  const { options, didError, isLoading } = useMessageTypeOptions({ search });

  const isDisabled = isReadOnly || isLoading || didError;
  const hasError = didError || !!isInvalid;

  return (
    <VisualComponent
      isDisabled={isDisabled}
      isLoading={isLoading}
      options={options}
      optionsLimit={optionsLimit}
      hasError={hasError}
      hasWarning={hasWarning}
      isOpenByDefault={isOpenByDefault}
      onChange={onChange}
      value={value}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      comparator={comparator}
      placeholder={t('v2.conditionBuilder.multiMessageTypePlaceholder')}
      search={search}
      setSearch={setSearch}
    />
  );
};
